module.exports = __webpack_public_path__ + "static/mission-img-2-94a6b722c3e03c31ccdb8a54ca62306a.jpg";